import { render, staticRenderFns } from "./ElementFactTableColumn.vue?vue&type=template&id=6757f610"
import script from "./ElementFactTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementFactTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports